module.exports = __webpack_public_path__ + "img/globe.8971b37f.png";